import styles from './Toggle.module.css';

interface ToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  labelledBy?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

export function Toggle({
  checked,
  onChange,
  label,
  labelledBy,
  disabled,
  size = 'md',
}: ToggleProps) {
  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={!labelledBy ? label : undefined}
        aria-labelledby={labelledBy}
        disabled={disabled}
        className={`${styles.track} ${size === 'sm' ? styles.sm : styles.md} ${checked ? styles.checked : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className={styles.thumb} />
      </button>
      {label && !labelledBy && <span className={styles.label}>{label}</span>}
    </div>
  );
}
